export default "__VITE_ASSET__DYoOcUE$__"